import { BrowserModule } from "@angular/platform-browser";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  APP_INITIALIZER
} from "@angular/core";
import { PruNavModule } from "global-navigation/src/app/pru-nav/pru-nav.module";
import { AppComponent } from "./app.component";
import { routing } from "./app.routing";
import { MyaccountsCommonModule } from "./component/myaccounts-common.module";
import { HomeinitService } from "./services/homeinit.service";
import { PruTimeoutModule } from "pru-timeout/src/app/modules/pru-timeout/pru-timeout.module";
import { appInitializerSessionCheck } from "./services/app-session-check/app-initializer-session-check";
import { UtilitiesModule } from './utilities/utilities.module';
import { MarketingMessagesManagerModule } from 'widgets/src/app/lib/components/marketing-messages-manager/marketing-messages-manager.module';
/**
 * @param homeinitService
 */
export function app_config(homeinitService: HomeinitService) {
  return () => homeinitService.getConfigService();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    UtilitiesModule,
    routing,
    PruNavModule,
    PruTimeoutModule,
    MyaccountsCommonModule,
    MarketingMessagesManagerModule
  ],
  providers: [
    appInitializerSessionCheck, // APP_INITIALIZER provider to run session check
    HomeinitService,
    {
      provide: APP_INITIALIZER,
      useFactory: app_config,
      deps: [HomeinitService],
      multi: true
    }
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent]
})
export class AppModule { }
